<template>
  <div class="lad-facebook-widget">
    <h3>{{ $t(`${base}.join_group`) }}</h3>

    <div
      class="fb-group"
      :data-href="groupUrl"
      :data-width="widgetWidth"
      :data-show-metadata="true"
      :data-show-social-context="true"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'LadFacebookWidget',
  props: {
    groupId: { type: String, default: '' },
  },
  data() {
    return {
      base: 'components.facebook',
      widgetWidth: '500px',
    }
  },
  computed: {
    groupUrl() {
      return `https://www.facebook.com/groups/${this.groupId}/`
    },
  },
  beforeMount() {
    this.setWidgetWidth()
  },
  mounted() {
    this.$fbsdk.load()
  },
  methods: {
    setWidgetWidth() {
      if (window.screen.availWidth < 500) {
        this.widgetWidth = ''
      }
    },
  },
}
</script>

<style lang="scss">
.lad-facebook-widget {
  text-align: center;

  .fb-group {
    width: 100%;

    & > span {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
